import moment from 'moment'
import React, { useCallback } from 'react'

import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { getFormattedPrice } from 'util/numbers'
import Label from './Label'

export function getStatusProps({ status, refunded }) {
  if (refunded) return { children: 'Refunded', color: 'groovy' }
  if (status === 'succeeded') return { children: 'Paid', color: 'groovy' }
  if (status === 'pending') return { children: 'Pending', color: 'golden' }
  return { children: 'Declined', color: 'berry' }
}

export default function StripeChargeRow({
  charge,
  charge: { id, amount, created, currency },
  doNavigatableSetState,
}) {
  const onClick = useCallback(
    () => {
      doNavigatableSetState({ id, type: 'order' })
    },
    [doNavigatableSetState, id]
  )
  if (charge)
    return (
      <NavigatableIntegrationWidgetCard.ListItem
        onClick={onClick}
        subTitle={`${moment.unix(created).format('Do MMM YYYY')}`}
        title={
          <>
            <Label {...getStatusProps(charge)} /> ·
            {getFormattedPrice(amount, currency)}
          </>
        }
      />
    )
  return null
}
